export enum DeletionProtection {

  MONTHS_3 = 'MONTHS_3',
  MONTHS_6 = 'MONTHS_6',
  YEARS_1 = 'YEARS_1',
  YEARS_2 = 'YEARS_2',
  YEARS_5 = 'YEARS_5',
  YEARS_10 = 'YEARS_10',
}
